import {FunctionalComponent, h} from "preact";
import TextEffects from "../../effects/textEffects";
import {MessageFrame} from "../../components/messageFrame";

const TextBox: FunctionalComponent<{
  name?: string;
  time?: string;
  msgID: string;
  msgText: string;
  disableEffects?: number[];
  tickCallback: () => void }> = ({
    name,
    time,
    msgID,
    msgText,
    disableEffects,
    tickCallback
  }) => {
    return (<MessageFrame clsName='' name={name} time={time}>
      <p id={`m_${msgID}`}>
          <TextEffects disableEffects={disableEffects} msgText={msgText} tickCallback={tickCallback} />
      </p>
    </MessageFrame>);
};

export default TextBox;
